import React, { useState } from 'react'
import { withStyles } from '@material-ui/core'
import Modal from 'uiKit/Modal'
import Select from 'uiKit/Select/Select'
import styled from 'styled-components'
import SubmitButton from 'uiKit/buttons/SubmitButton'
import { SectionOption } from '../../../reducers/questions'

interface NewSectionProps {
  isOpen: boolean
  onClose: () => void
  onSave: (sectionName: SectionOption) => void
  classes: any
  sectionOptions?: Array<SectionOption>
  sections?: Array<SectionOption>
}

const modalStyle = theme => ({
  customModalPaper: {
    padding: '0px!important',
    height: '264px!important',
    width: '701px!important',
    overflow: 'visible', // Allow content to overflow for dropdown
  },
})

const NewSection: React.FC<NewSectionProps> = ({ isOpen, onClose, onSave, classes, sectionOptions, sections = [] }) => {
  const [sectionName, setSectionName] = useState<SectionOption | null>(null)
  const [error, setError] = useState('')

  const defaultSectionOptions = []

  const options = sectionOptions || defaultSectionOptions

  const handleSave = () => {
    if (!sectionName) {
      return
    }
    // Block if a section with the same value already exists
    const exists = Array.isArray(sections)
      ? sections.some(s => String(s.value) === String(sectionName.value))
      : false
    if (exists) {
      setError('This section already exists')
      return
    }
    onSave(sectionName) // Keep for backward compatibility
    setSectionName(null)
    onClose()
    setError('')
  }

  const handleChange = (selectedOption: any) => {
    setSectionName(selectedOption)
    if (selectedOption) {
      setError('')
    }
  }

  const onCloseModal = () => {
    onClose()
    setError('')
    setSectionName(null)
  }

  return (
    <Modal open={isOpen} onClose={onCloseModal} classes={{ paper: classes.customModalPaper }}>
      <ContentContainer>
        <h2>Add a Section</h2>
        <div style={{ padding: '0 24px' }}>
          <FormLabel>
            Section<span style={{ color: 'red' }}>*</span>
          </FormLabel>
          <Select
            value={sectionName}
            placeholder="Select a section type"
            options={options}
            onChange={handleChange}
            error={!!error}
            errorMessage={error}
            isClearable={false}
            menuPortalTarget={document.body} // Render menu in a portal to avoid z-index issues
            styles={{
              menuPortal: base => ({ ...base, zIndex: 9999 }), // Ensure dropdown is above modal
              menu: base => ({ ...base, zIndex: 9999 }),
            }}
          />
        </div>
        <ButtonContainer>
          <SubmitButton
            styles={{ width: 147, height: 42 }}
            type="primary_with_border"
            title="Cancel"
            onClick={onCloseModal}
          />
          <SubmitButton
            styles={{ width: 147, height: 42, opacity: sectionName ? 1 : 0.5 }}
            type="primary"
            title="Save"
            onClick={handleSave}
          />
        </ButtonContainer>
      </ContentContainer>
    </Modal>
  )
}

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
  padding: 24px 0 20px 0;
  height: 100%;
  h2 {
    font-size: 20px;
    font-weight: 600;
    padding: 0 24px;
    color: var(--color-oxford-blue);
    line-height: 18px;
    margin-bottom: 16px;
  }
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  gap: 14px;
  padding: 0 24px;
  border-top: 1px solid var(--color-issabeline-grey);
  padding-top: 20px;
`

const FormLabel = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: var(--color-text-form-label);
  margin-bottom: 8px;
`

export default withStyles(modalStyle)(NewSection)
